export default __webpack_public_path__ + "static/N0204-e9f2eaef1288a27dbafb83745397493f.png";